import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FormlyModule } from "@ngx-formly/core";
import { IconsModule } from "../icons/icons.component.module";
import { CalculateImfPercentilesModalComponent } from "./calculate-imf-percentiles-modal.component";
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    declarations: [CalculateImfPercentilesModalComponent],
    exports: [CalculateImfPercentilesModalComponent],
    imports: [CommonModule, IconsModule, FormlyModule, ReactiveFormsModule,MatDialogModule,MatDividerModule,MatIconModule,MatButtonModule],
  })
  export class CalculateImfPercentilesModalComponentModule {}
  